import React, { Component } from 'react';
import { connect } from 'shalala';
import { Link } from 'react-router-dom';
import { Guardian } from '@xaamin/guardian';

import { useStore } from '../../store';
import { Spinner, Col, Row, Button } from 'react-bootstrap';
import Loading from '../../facturotopia/loading/Loading';
import PageHeader from '../../support/page-header/PageHeader';

class SociosDeNegocioInfo extends Component {

  state = {}

  constructor(props) {
    super(props);

    const { data = {}} = props.location.state || {};
    const { id } = this.props.match.params;

    this.state = {
      data: !!data.id ? { ...data } : { id }
    }

    props.setData(this.state.data);
  }

  componentDidMount() {
    const { data } = this.state;

    if (!!data.razon_social) {
      return;
    }

    this.props.get(data.id);
  }

  render() {
    const { data = {}, busy } = this.props;

    const edit = {
      pathname: `/modulos/socios/${data.id}/editar`,
      state: {
        data: {...data}
      }
    }

    if (!!busy) {
      return <Loading className="text-info" />;
    }

    return (
      <>
        <PageHeader to="/modulos/socios" text="Socios" />

        <h5>
          <Row>
            <Col>
              { !!busy && (
                <Spinner animation="border" role="status" size="sm" className="mr-3">
                  <span className="sr-only">Loading socio info...</span>
                </Spinner>
                )
              }
              { data.razon_social || '...' }
            </Col>
          </Row>

        </h5>

        { !!data.razon_social && (
          <div>

            <div className="pb-2">
              <strong>Invitación: </strong> { data.created_at }
              <br />
              <strong>Confirmación: </strong> { data.aceptado_at || 'Pendiente' }
              <br />
            </div>

            { Guardian.allows('socios.negocio.editar') && (
              <Button as={ Link } variant="secondary" className="text-muted"
                  to={ edit }
                >
                Editar
              </Button>
            )}

            <div className="d-block mt-3 mb-2">
              <strong className="text-muted">Ultimas facturas</strong>
            </div>

          </div>
        )}
      </>
    );
  }
}

const mapState = (state) => {
  return state.modulo.socios.info;
}

const mapActions = (actions) => {
  return actions.modulo.socios.info;
}

export default connect(useStore, mapState, mapActions)(SociosDeNegocioInfo);